module.exports = __webpack_public_path__ + "media/images/athletes/138-4264763a4f5c006fecc002954d1cb0a5.png";